interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <div className={`mb-8 flex flex-col gap-2 md:mb-12 ${alignment}`}>
      <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
        <i className="ri-magic-line"></i>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h2>
      {subtitle && (
        <p className="max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
          {subtitle}
        </p>
      )}
    </div>
  );
}